import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UsersService } from '../../services/users.services';
import { CommonService } from '../../services/common.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
declare var $: any;
import { NgxSpinnerService } from 'ngx-spinner';
import { ExcelService } from '../../services/excel.service';
import swal from 'sweetalert2';


@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {

  users: MatTableDataSource<any>;
  displayedColumns: string[];
  user_account: any;
  filterMenuVisible: boolean = false;

  driverIdentifications = [];
  selectedDriverIdentifications = [];
  driverIdentificationsSettings = {};

  driverNames: any[] = [];
  selectedDriverNames = [];
  driverNamesSettings = {};
  reportData: any = []

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  constructor(
      private route: ActivatedRoute,
      private router: Router,
      private usersService: UsersService,
      private commonService: CommonService,
    private excelService: ExcelService,
    private spinner: NgxSpinnerService,

  ) { }


  toggleFilterMenu() {
    this.filterMenuVisible = !this.filterMenuVisible;
  }

  ngOnInit() {
    this.displayedColumns = ["document", "name", "email", "status", "edit"];
    this.getUsers();
    this.setSpinnersSettings()
  }

  toEdit(id) {
    this.router.navigate(['/home/user/' + id])
  }

  setSpinnersSettings() {
    this.driverIdentificationsSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'identification',
      selectAllText: 'Todos',
      unSelectAllText: 'Deseleccionar Todos',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      searchPlaceholderText: "Buscar"
    };

    this.driverNamesSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Todos',
      unSelectAllText: 'Deseleccionar Todos',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      searchPlaceholderText: "Buscar"
    };

  }

  filterDrivers(): void {
    this.spinner.show();
    var identifications = this.selectedDriverIdentifications.map(({ identification }) => "'" + identification + "'").toString();
    var names = this.selectedDriverNames.map(({ name }) => "'" + name + "'").toString();
    console.log(identifications)
    console.log(names)

    this.usersService.filterUsers(this.commonService.getUserName(), identifications, names)
      .then(response => {
        this.spinner.hide()
        this.users = response;
        this.user_account = response.user_account;

        this.users = new MatTableDataSource(response);
        this.users.paginator = this.paginator;
        this.users.paginator._intl.itemsPerPageLabel = "Filas por Página:"
        this.users.sort = this.sort;
      

        this.reportData = []
        for(var i in response){
          var obj = response[i]
          this.setReportData(obj)
        }
      // Esconde el paginador porque no es posible cambair la paginación por problemas con el componente
      $(".mat-paginator-page-size").css("display", "none")
    });
  }

  getUsers(): void {
    let that = this;
    this.usersService.getUsers(this.commonService.getUserName())
      .then(response => {
        this.reportData = []
        for(var i in response){
          var obj = response[i]
          this.driverIdentifications.push({ id: obj.id, identification: obj.identification })
          this.driverNames.push({ id: obj.id, name: obj.name })
          this.setReportData(obj)
        }

        console.log(this.driverNames)

        this.users = response;
        
        this.user_account = response.user_account;

        this.users = new MatTableDataSource(response);
        this.users.paginator = this.paginator;
        this.users.paginator._intl.itemsPerPageLabel = "Filas por Página:"
        this.users.sort = this.sort;
      
      // Esconde el paginador porque no es posible cambair la paginación por problemas con el componente
      $(".mat-paginator-page-size").css("display", "none")
    });

  }
  applyFilter(filterValue: string) {
    this.users.filter = filterValue.trim().toLowerCase();
    if (this.users.paginator) {
      this.users.paginator.firstPage();
    }
  }


  exportToExcel() {

    if (this.reportData.length > 0) {
      this.excelService.exportAsExcelFile(this.reportData, 'Lista de Conductores');
    } else {
      swal({
        title: 'No hay datos para exportar',
        text: '',
        type: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#ff5370',
        confirmButtonText: 'Volver',
        // cancelButtonText: 'No'
      }).catch(swal.noop);
    }
  }
  setReportData(driverObject) {
    this.reportData.push({
      Nombre: driverObject.name,
      Identificacion: driverObject.identification,
      Email: driverObject.email,
    })
  }

  // ngAfterViewInit(){
  //   this.users.paginator = this.paginator;
  //   console.log(this.users.paginator)
  //   this.users.sort = this.sort;
  // }
  _updatePaginator(filteredDataLength: number) {
    Promise.resolve().then(() => {
      if (!this.paginator) { return; }
      
      this.paginator.length = filteredDataLength;
      console.log(this.paginator)

      // If the page index is set beyond the page, reduce it to the last page.
      console.log(this.paginator.pageIndex)
      if (this.paginator.pageIndex > 0) {
      const lastPageIndex = Math.ceil(this.paginator.length / this.paginator.pageSize) - 1 || 0;
        this.paginator.pageIndex = Math.min(this.paginator.pageIndex, lastPageIndex);
      }
    });
  }

  onIdentificationSelect(item: any) {
    console.log(this.selectedDriverIdentifications)
  }
  onDeSelectIdentification(items: any) {
    console.log(this.selectedDriverIdentifications)
  }

}



// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/components/users/users.component.ts